// extracted by mini-css-extract-plugin
export default {"row":"f_IKcHAW1gyDUzaEJYax","title":"DLubfsR_vke7t9YC2QMQ"};